'use strict';

/**
 * Initializes every reCAPTCHA placeholder found on the current page.
 *
 * Each placeholder supplies the endpoint and form name used to request the
 * server-rendered reCAPTCHA markup. The related submit button remains disabled
 * when reCAPTCHA is enabled for that form.
 *
 * @param {HTMLElement|jQuery} [context] - Optional container used to scope placeholder lookup
 */
function init(context) {
    // Keep the original page-wide lookup when no explicit container is supplied.
    var $recaptchaElements = context ? $(context).find(".recaptcha") : $(".recaptcha");

    // Avoid starting the initialization flow when the page has no placeholders.
    if ($recaptchaElements.length > 0) {

        // A page can host multiple forms, each with its own reCAPTCHA configuration.
        $recaptchaElements.each(function () {

            // Read the route and form context exposed through the placeholder data attributes.
            var url = $(this).data("recaptcha-url");
            var name = $(this).data("recaptcha-name");

            // Trigger the current data lookup even though its value is not retained by this flow.
            $(this).data("recaptcha-type");

            // Keep a reference to the placeholder for use inside the asynchronous callback.
            var $this = $(this);

            // Ask the server whether reCAPTCHA is enabled and request its rendered template.
            $.ajax({
                method: "POST",
                datatype: 'json',
                url: url,
                data: {
                    name: name
                }
            }).done(function (response) {
                // Process only non-empty responses returned by the enablement endpoint.
                if (response) {

                    // Enablement requires both the mapping flag and successfully rendered markup.
                    if (response.enable && response.template) {

                        // Prevent submission until the version-specific reCAPTCHA flow unlocks it.
                        $(".g-recaptcha-button-" + response.nameForm).addClass("disabled");

                        // Store the resolved state on the placeholder for other storefront code.
                        $this.data("recaptcha-enable", true);

                        // Inject the server-rendered v2 or v3 markup into this placeholder.
                        $this.append(response.template);
                    } else {
                        // Leave the form usable when reCAPTCHA is disabled or markup is unavailable.
                        $(".g-recaptcha-button-" + response.nameForm).removeClass("disabled");
                    }
                }
            });
        });
    }
}

module.exports = {
    init: init
}
